import { Card, CardBody } from '@windmill/react-ui'

import Image from 'next/image'

const HorizontalContentCard = ({ cardDetails }) => {
    return (
        <>
            <Card
                className="relative text-left shadow-none base-card"
                itemScope
                itemType="https://schema.org/WebPage"
            >
                <CardBody className="flex card-body">
                    <div>
                        <div className="h-[164px] w-[164px] ipad:w-[80px] ipad:h-[80px] mobile:w-16 mobile:h-16 relative rounded-xl top-1">
                            <div className="absolute w-full h-full bg-common-white rounded-xl "></div>
                            <Image
                                src={cardDetails.img}
                                alt={cardDetails.title}
                                layout="responsive"
                                width={164}
                                height={164}
                                itemProp="image"
                            />
                        </div>
                    </div>
                    <div className="flex flex-col ml-5">
                        <h3 className="title" itemProp="headline">
                            {cardDetails.title}
                        </h3>
                        <p className="mb-0" itemProp="description">
                            {cardDetails.description}
                        </p>
                    </div>
                </CardBody>
            </Card>
        </>
    )
}
export default HorizontalContentCard
